module.exports = __webpack_public_path__ + "static/media/za.665d8c08.webp";